<template>
  <div>
    <div class="h-1"></div>
    <div class="container">
      <div class="row text-center pt-40 pb-30">
        <div class="col-lg-12">
          <div class="h2 mb-40">联系我们</div>
          <p>
            地址：北京市西城区复兴门内大街45号院<br />
            <!-- 电话：<a href="tel:13520158992">13520158992</a> -->
          </p>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="
                copyright-item
                d-block d-md-flex
                justify-content-center
                align-items-center
              "
            >
              <p class="pr-2">
                <a href="https://beian.miit.gov.cn" target="_blank" style="color: #337ab7;">
                  京ICP备2025143440号
                </a>
              </p>

              <p>© Copyright 2025-2026, All Rights Reserved</p>

              <!--
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">Advertise</a></li>
                <li><a href="#">Privacy & Policy</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.h-1 {
  height: 1px;
  background-color: #f4f4f4;
}
</style>